var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuentasUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key-24-outlined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0417 31.875C46.0417 35.787 49.213 38.9583 53.125 38.9583C57.0371 38.9583 60.2084 35.787 60.2084 31.875C60.2084 27.963 57.0371 24.7917 53.125 24.7917C49.213 24.7917 46.0417 27.963 46.0417 31.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3334 31.875C28.3334 18.183 39.433 7.08334 53.125 7.08334C66.8171 7.08334 77.9167 18.183 77.9167 31.875C77.9167 45.5671 66.8171 56.6667 53.125 56.6667H46.0417V63.75H38.9584V70.8333H31.875V77.9167H7.08337V58.7413L28.8576 36.9672C28.5103 35.305 28.3334 33.6009 28.3334 31.875ZM38.9584 56.6667V49.5833H53.125C62.9051 49.5833 70.8334 41.6551 70.8334 31.875C70.8334 22.095 62.9051 14.1667 53.125 14.1667C43.345 14.1667 35.4167 22.095 35.4167 31.875C35.4167 33.641 35.6742 35.3684 36.1749 37.0206L36.7905 39.0516L14.1667 61.6753V70.8333H24.7917V63.75H31.875V56.6667H38.9584Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuentasUsuario);
export default __webpack_public_path__ + "static/media/cuentas_usuario.be6abc8c1025b8c22d2496dba4bdad98.svg";
export { ForwardRef as ReactComponent };